<template>
  <div>
    <v-container>
      <v-layout wrap row avatar>
        <v-flex xs3 sm2 class="pa-2">
            <v-img
              :src="product.photourl.split(';;')[0]"
              :alt="product.name"
              v-if="product.photourl.split(';;').length > 0"
              lazy
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img>
        </v-flex>

        <v-flex xs7 sm8 class="pl-2 pr-2 pt-2">
          <v-list-tile-title
            style="cursor: pointer"
            :style="{ color: theme.color }"
            @click="$emit('showProduct', product.id)"
            >{{ product.name }}</v-list-tile-title
          >
          <div>
            <template v-if="product.option"
              >({{ product.option }})</template
            >
          </div>
          <div class=" warning--text" v-if="product.cart_remark">
            {{ $t("Remark") }}: {{ product.cart_remark }}
          </div>
          <v-list-tile-sub-title>
            <p class="price">
              <template v-if="product.bundleprice != product.price * product.quantity">
                <span class="discount" style="margin-right:5px"
                  >{{ currencySign }}{{ (product.price * product.quantity) | decimalFormat }}</span
                >
                {{ currencySign }}{{ product.bundleprice | decimalFormat }}
              </template>
              <template v-else>
                <span
                  v-if="product.discountprice != null && product.discountprice != product.price"
                  class="discount"
                  style="margin-right:5px"
                  >{{ currencySign }}{{ (product.price * product.quantity) | decimalFormat }}</span
                >
                {{ currencySign
                }}{{
                  ((product.discountprice != null && product.discountprice != product.price
                    ? product.discountprice
                    : product.price) *
                    product.quantity)
                    | decimalFormat
                }}
              </template>
            </p>
            <div v-if="currentStock != null && currentStock[2] > 0">
              <template v-if="product.categoryid == 10625"
                >x</template
              >
              <v-btn
                v-if="product.categoryid != 10625"
                small
                fab
                outline
                :color="theme.color"
                @click="removeCount()"
                :disabled="loading == true || (isCDS && category.name == 'Limit Order 1 Piece')"
                class="ma-0 pa-0 mt-2 mb-2"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <span
                style="width: 30px;display:inline-block;margin-left:5px;margin-right:5px;text-align:center"
                >{{ quantity }}</span
              >

              <v-btn
                v-if="product.categoryid != 10625"
                small
                fab
                outline
                :color="theme.color"
                @click="addCount()"
                :disabled="
                  quantity == currentStock[2] ||
                    (isCDS && quantity >= 10) ||
                    loading == true ||
                    (isCDS && category.name == 'Limit Order 1 Piece')
                "
                class="ma-0 pa-0 mt-2 mb-2"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <div v-if="currentStock">
                <span class="caption" v-if="parseInt(currentStock[2]) == 1"
                  >({{ $t("Only {item} item left", { item: currentStock[2] }) }})</span
                >
                <span
                  class="caption"
                  v-else-if="parseInt(currentStock[2]) > 0 && currentStock[2] < 5"
                  >({{ $t("Only {item} items left", { item: currentStock[2] }) }})</span
                >
              </div>
            </div>
            <div class="small" style="color:red" v-else>{{ $t("Sold Out") }}</div>
          </v-list-tile-sub-title>
        </v-flex>
        <v-flex xs2 sm2 class="text-xs-right">
          <v-btn
            flat
            fab
            small
            :color="theme.color"
            @click="$emit('deleteItem')"
            :disabled="loading == true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["value", "stock", "loading", "categories"],
  data() {
    return {
      product: this.value,
      quantity: this.value.quantity,
    };
  },
  computed: {
    ...mapGetters({
      isWholesale: "getWholesaleStatus",
      wholesale: "getWholesale",
      cart: "getCart",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    isKhaiwhan() {
      return this.pageProfile && this.$store.state.khaiwhan.includes(this.pageProfile.pageid);
    },
    category() {
      return this.categories.find((el) => el.id == this.product.categoryid);
    },
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    currencySign: function() {
      if (this.pageProfile && this.pageProfile.pageid == "402026927063253") {
        return "$";
      } else if (this.pageProfile.pageid == "751241271893504") {
        return "K";
      } else {
        return "฿";
      }
      // if (this.product && this.product.currency) {
      //   switch (this.product.currency.toUpperCase()) {
      //     case "THB":
      //       return "฿";

      //     default:
      //       return "$";
      //   }
      // }
      // return "$";
    },
    currentStock: function() {
      let vm = this;

      if (vm.stock.length == 0) {
        return null;
      }

      let option = null;
      option = vm.stock.find(function(val) {
        return (
          (vm.product.optionDetail && val[0] == vm.product.optionDetail[0]) ||
          (val[1] == vm.product.option.split(" - ")[0] &&
            ["khaiwhan", "gaigao"].includes(vm.pageProfile.type))
        );
      });
      return option;
    },
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.product = newVal;
        this.quantity = newVal.quantity;
      },
      deep: true,
    },
  },
  methods: {
    addCount: function() {
      let vm = this;
      if (vm.quantity < vm.currentStock[2]) {
        vm.quantity += 1;
        vm.$set(vm.product, "quantity", vm.quantity);
        vm.$store.dispatch("updateCartStock", {
          id: vm.product.id,
          quantity: vm.quantity,
          stockid: vm.currentStock[0],
        });
        vm.$emit("input", vm.product);
        vm.$emit("onUpdateStock");
      }
    },
    removeCount: function() {
      let vm = this;
      if (vm.quantity > 1) {
        vm.quantity -= 1;
        vm.$set(vm.product, "quantity", vm.quantity);
        vm.$store.dispatch("updateCartStock", {
          id: vm.product.id,
          quantity: vm.quantity,
          stockid: vm.currentStock[0],
        });
        vm.$emit("input", vm.product);
        vm.$emit("onUpdateStock");
      }
    },
  },
};
</script>

<style scoped></style>
